import { AlertCircle, CheckCircle2 } from "lucide-react";

interface MessageBannerProps {
  tone?: "error" | "success" | "info";
  children: string;
}

export function MessageBanner({ tone = "error", children }: MessageBannerProps) {
  const Icon = tone === "success" ? CheckCircle2 : AlertCircle;
  return (
    <div className={`banner banner--${tone}`} role={tone === "error" ? "alert" : "status"}>
      <Icon size={17} aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}
